import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-amenities-list',
    templateUrl: './settings-amenities-list.component.html',
    styleUrls: ['./settings-amenities-list.component.scss']
})
export class SettingsAmenitiesListComponent {

    constructor(
        public urlService: UrlService,
        public settingsAmenitiesService: SettingsAmenitiesService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsAmenitiesService.data.allSettingsAmenities.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        this.settingsAmenitiesService.emptyNotificationArrays();
        if (checked && this.settingsAmenitiesService.selectedItemData) {
            this.settingsAmenitiesService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.settingsAmenitiesService.selectedItemData = null;
            setTimeout(() => {
                this.settingsAmenitiesService.toggleDetailedView(selectedItem, true);
                this.settingsAmenitiesService.formatNotificationSettingsRoles();
            });
        }
    }

    uncheckItem(): void {
        this.settingsAmenitiesService.data.allSettingsAmenities.data.forEach((item) => item.checked = false);
    }

    deleteAmenity(item, event): void {
        event.stopPropagation();
        this.settingsAmenitiesService.deleteAmenity(item);
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsAmenitiesService.buildings.forEach(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-list/settings-amenities-list.component.ts